// @ts-check
// src/components/StatusBadge.js — Faza D.3.4 lit-html
//
// Kolorowy badge dla statusów (zamówień, faktur, ticketów, etc.).
//
// Variants:
//   - 'success'     → zielony
//   - 'warning'     → pomarańczowy
//   - 'error'       → czerwony
//   - 'info'        → niebieski
//   - 'neutral'     → szary (default)
//   - custom HEX color np. { color: '#8b5cf6' }
//
// Sizes:
//   - 'xs' (default), 'sm', 'md'

import { html } from 'lit-html';
import { styleMap } from 'lit-html/directives/style-map.js';

const VARIANTS = {
  success: { bg: '#22c55e22', color: '#16a34a' },
  warning: { bg: '#f59e0b22', color: '#d97706' },
  error: { bg: '#ef444422', color: '#dc2626' },
  info: { bg: '#3b82f622', color: '#2563eb' },
  neutral: { bg: '#6b728022', color: '#4b5563' },
};

const SIZES = {
  xs: { padding: '1px 6px', fontSize: '10px' },
  sm: { padding: '2px 8px', fontSize: '11px' },
  md: { padding: '3px 10px', fontSize: '12px' },
};

/**
 * @param {Object} opts
 * @param {string} opts.label - tekst badge
 * @param {string} [opts.variant='neutral'] - success | warning | error | info | neutral
 * @param {string} [opts.color] - custom HEX (np. '#8b5cf6') — nadpisuje variant
 * @param {string} [opts.size='xs'] - xs | sm | md
 * @param {string} [opts.icon] - opcjonalna lucide icon name (np. 'check-circle')
 * @returns {import('lit-html').TemplateResult}
 */
export function StatusBadge({ label, variant = 'neutral', color, size = 'xs', icon }) {
  const v = VARIANTS[variant] || VARIANTS.neutral;
  const s = SIZES[size] || SIZES.xs;
  const bgColor = color ? color + '22' : v.bg;
  const fgColor = color || v.color;

  const baseStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: s.padding,
    fontSize: s.fontSize,
    fontWeight: '600',
    background: bgColor,
    color: fgColor,
    border: `1px solid ${fgColor}44`,
    borderRadius: '9999px',
    whiteSpace: 'nowrap',
  };

  return html`
    <span style=${styleMap(baseStyles)}>
      ${icon ? html`<i data-lucide=${icon} style="width:11px;height:11px"></i>` : ''}
      ${label}
    </span>
  `;
}
